import * as yup from "yup";

export const schemaMatrizBcg = (translate: Function) => yup.object().shape({
	mac001Titulo: yup.string().required(translate("Título é requerido")),
	mac001Descricao: yup.string(),
	mac001Datainicial: yup.date().nullable().required(translate("Data Inicial é requerida")),
	mac001Datafinal: yup.date().nullable().required(translate("Data Final é requerida")).min(
		yup.ref("mac001Datainicial"),
		translate("Data Final tem que ser após a Data Inicial")
	),
	mac001Ativo: yup.string().oneOf(["S", "N"]),
	matbc002: yup.array()
		.min(1,translate("Ao menos uma permissão deve ser informada"))
		.required(translate("Ao menos uma permissão deve ser informada"))
		.unique(translate("Usuários não podem ser repetidos"), (a: any) => a.mac002Efa005Id, (a: any) => !a.mac002Efa004Id)
		.unique(translate("Grupo de Usuários não podem ser repetidos"), (a: any) => a.mac002Efa004Id, (a: any) => !a.mac002Efa005Id),
	matbc003: yup.array()
		.min(1,translate("Ao menos um Item BCG deve ser informado"))
		.required(translate("Ao menos um Item BCG deve ser informado"))
		.unique(translate("Itens BCG não podem ser repetidos"), (a: any) => a.mac003Taa013Id)
});

export const schemaDeleteMatrizBcg = (translate: Function) => yup.object().shape({
	mac001Titulo: yup.string().required(translate("Titulo da análise não confere")).oneOf([yup.ref("mac001TituloConfirmation")], translate("Titulo da análise não confere"))
});
